module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "information-container"
  }, [(_vm.data) ? _c('draggable', {
    staticClass: "is-multiline documents",
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }, _vm._l((_vm.data), function(information) {
    return _c('BankRequirementItem', {
      key: information.id,
      attrs: {
        "information": information
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered add-document"
  }, [_c('span', {
    staticClass: "button-wrapper link",
    on: {
      "click": function($event) {
        return _vm.handleAddRequiredInformation()
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить информацию\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22042c12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/BankRequirement.vue
// module id = 908
// module chunks = 0